/**
 * Public constants for `BuilderMediaBlock`. Lives in its own module so
 * `register-components.js` can import the disclaimer text without pulling
 * the full `BuilderMediaBlock` component (Vimeo helpers, MUI styled
 * components, image optimization, etc.) into the eager bundle. The
 * component's `dynamic()` import in `register-components.js` is the
 * load-bearing lazy-load — eagerly importing the full module just to read
 * one string defeats it (PD-34301, CodeRabbit catch).
 *
 * `BuilderMediaBlock/index.jsx` re-exports `DEFAULT_DISCLAIMER_TEXT` for
 * any existing consumer that imports from the component directly.
 */

export const DEFAULT_DISCLAIMER_TEXT =
  'Image is for illustrative purposes only. Forward-looking statements, projections, ' +
  'and depictions of products, services, or outcomes shown in this media are subject ' +
  'to risks and uncertainties. Past performance does not guarantee future results.';
